import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HeroSection } from '@trashlab/sitesapp/src/organizations/patriot/template/components/shared/hero-section';
import { CtaSection } from '@trashlab/sitesapp/src/organizations/patriot/template/components/shared/cta-section';
import { FAQ } from '@trashlab/sitesapp/src/organizations/patriot/template/components/shared/faq-section';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/patriot/contexts/use-tenant-context';
import { VideoGuide } from '@trashlab/sitesapp/src/organizations/patriot/template/components/dumpster-faq/video-guide';
import { MaterialGuide } from '@trashlab/sitesapp/src/organizations/patriot/template/components/dumpster-faq/material-guide';
import { HeavyDebrisInfo } from '@trashlab/sitesapp/src/organizations/patriot/template/components/dumpster-faq/heavy-debris-info';
import { RequestServiceForm } from '@trashlab/sitesapp/src/organizations/patriot/template/components/request-service/request-service-form';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/patriot/lib/utils/get-variant-value';

const DumpsterFaq = () => {
  const { website } = useTenantContext();
  const dumpsterFaqHeroSubtitle = useVariantValue(
    'FAQ_HERO_SUBTITLE',
    'Get instant answers to your queries about renting a dumpster, as well as our drop-off and pickup services. Explore commonly asked questions, detailed responses, and essential information to streamline your waste management process.',
  );

  return (
    <>
      <HeroSection
        title="Renting a dumpster FAQ"
        content={dumpsterFaqHeroSubtitle}
      />
      <FAQ
        accordionOnly
        faqType="how-to"
        customSubtitle="Need help renting a dumpster?"
        customTitle="How to rent a dumpster"
      />
      <VideoGuide />
      <FAQ
        accordionOnly
        faqType="residential"
        customSubtitle={`${
          website?.organization?.name || "Our company's"
        } residential dumpsters`}
        customTitle="Residential dumpster rental FAQ"
        customDescription="Our FAQ section provides key details about our residential dumpster rental services, answering common questions and offering guidance for renting a dumpster."
        withBackground
      />
      <HeavyDebrisInfo />
      <FAQ
        accordionOnly
        faqType="rolloff"
        customSubtitle={`${
          website?.organization?.name || "Our company's"
        } Rolloff dumpsters`}
        customTitle="Rolloff dumpster rental FAQ"
        customDescription="Get valuable information on our rolloff dumpster rental services in our FAQ section, covering essential procedures, policies, and practical tips for contractors renting a dumpster."
        withBackground
      />
      <RequestServiceForm
        customSubtitle="Get your questions answered today"
        customTitle="Don't see your question?"
        customDescription="If your specific question isn't covered in our FAQ, we're here to help! Fill out the form below with your query, and our expert team will get back to you with a detailed response to cater precisely to your unique needs."
      />
      <CtaSection withBackground />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dumpster-faq',
  component: DumpsterFaq,
});
